import React from 'react';
import { Link } from 'carbon-components-react';
import { useHistory } from 'react-router-dom';
import { APP_URL } from 'types';
import { Network } from '@carbon/pictograms-react';

export const NoRowData: React.FC<{}> = () => {
  const history = useHistory();

  return (
    <div className="enquiries-no-data--wrapper">
      <Network />
      <h2 className="enquiries-no-data--body-text">
        There is no data to display or the data could not be loaded
      </h2>
      <p>
        <Link onClick={() => history.push(`${APP_URL.DASHBOARD}`)} href="#">
          Home
        </Link>
      </p>
    </div>
  );
};

export default NoRowData;
